import { SessionBaseComponent } from './../../../../shared/components/session.base.component';
import { Component, OnInit, Inject, Injector } from '@angular/core';
import { UserService as UserDataService } from '../../services/user-service.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalConstants } from 'src/app/core/constants/global-constants.constant';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'laas-password-change',
  templateUrl: './password-change.component.html',
  styleUrls: ['./password-change.component.scss']
})
export class PasswordChangeComponent extends SessionBaseComponent implements OnInit {

  oldPassword: string;
  newPassword: string;
  rePassword: string;

  //form
  changeForm: FormGroup;
  submitted: boolean;

  constructor(
    injector: Injector,
    private fb: FormBuilder,
    private userDataService: UserDataService,
    private localStorageService: LocalStorageService,
  ) {
    super(injector);
    this.oldPassword = "";
    this.newPassword = "";
    this.rePassword = "";
    this.submitted = false;

    this.changeForm = this.fb.group({
      oldPassword: ["", Validators.required],
      newPassword: ["", Validators.required],
      rePassword: ["", Validators.required]
    });
  }

  get language(): string {
    return this.localStorageService.getItem(GlobalConstants.languageKey);
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();
  }

  changePassword(event: any): void{
    this.submitted = true;

    if (this.changeForm.invalid) {
      //請檢查是否有必填欄位尚未填寫
      this.translateService.get('ChangePass.Alert.CheckRequiredFields')
      .subscribe({
        next: result => {
          this.toastService.warn(result);
        }
      });
      return;
    }

    if (this.newPassword !== this.rePassword) {
      //兩密碼不相符
      this.translateService.get('ChangePass.Error.PasswordMatch')
      .subscribe({
        next: result => {
          this.toastService.error(result);
        }
      });
      return;
    }
    
    // 密碼檢核邏輯
    // 密碼長度至少8個字元，包含大小寫英數字及特殊字元，且不能包含帳號或舊密碼
    const patterns = [
      /[A-Z]/,                     // 至少一個大寫字母
      /[a-z]/,                     // 至少一個小寫字母
      /\d/,                        // 至少一個數字
      /[!@#$%^&*(),.?":{}|<>]/     // 至少一個特殊字元
    ];
    const matchCount = patterns.filter((regex) => regex.test(this.newPassword)).length;

    const isLengthValid = this.newPassword.length >= 8;
    const isAccountOrOldPasswordIncluded =
      this.newPassword.includes(this.userProfile.loginAccount) ||
      this.newPassword === this.oldPassword;

    if (!isLengthValid || matchCount < 3 || isAccountOrOldPasswordIncluded) {
      this.toastService.error(this.translateService.instant('PasswordModification.Message.PasswordPolicyError'));
      return;
    }

    const changeObj: any = {
      uuid: this.userProfile.uuid,
      newPassword: this.newPassword,
      oldPassword: this.oldPassword,
      loginAccount: this.userProfile.loginAccount,
      language: this.language
    };

    this.userDataService.changePassword(changeObj).subscribe({
      next: result => {
        //變更成功
        this.translateService.get('ChangePass.Info.ChangeSuccess')
        .subscribe({
          next: result => {
            this.toastService.info(result);
          }
        });
        this.routeStateService.loadPrevious();
      },
      error: err => {
        this.toastErrorMessage(err.error);
      }
    });

  }

  // convenience getter for easy access to form fields
  get f() { return this.changeForm.controls; }

}
